import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import SignInEmployee from "./pages/SignInEmployee";
import SignInAdmin from "./pages/SignInAdmin";
import AdminDashboard from "./pages/Dashboardpages/AdminDash/AdminDashboard";
import EmployeeDashboardsMain from "./pages/EmployeeDashboard/EmployeeDashboardsMain";
import Leave from "./pages/Dashboardpages/AdminDash/Leave";
import Employees from "./pages/Dashboardpages/AdminDash/Employees";
import Main from "./pages/Dashboardpages/AdminDash/Main";
import EmMain from "./pages/EmployeeDashboard/EmMain";
import EmLeaves from "./pages/EmployeeDashboard/EmLeaves";
import Department from "./pages/Dashboardpages/AdminDash/Department";
import AdminNotification from "./pages/Dashboardpages/AdminDash/AdminNotification";
import ViewSingleEmployee from "./pages/Dashboardpages/AdminDash/ViewSingleEmployee";
import PrivateRoute from "./pages/Dashboardpages/AdminDash/PrivateRoute";
import PrivateEmRoute from "./pages/EmployeeDashboard/PrivateEmRoute";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/employeeSignin" element={<SignInEmployee />} />
        <Route path="/adminLogin" element={<SignInAdmin />} />
     
          <Route path="/admin/mainDash/" element={<AdminDashboard />}>
            <Route path="leaves" element={<Leave />} />
            <Route path="employees" element={<Employees />} />
            <Route path="main" element={<Main />} />
            <Route path="department" element={<Department />} />
            <Route path="notification" element={<AdminNotification />} />
            <Route path="employees/view" element={<ViewSingleEmployee />} />
          </Route>
  
       
          <Route
            path="/employee/mainDashboard/"
            element={<EmployeeDashboardsMain />}
          >
            <Route path="main" element={<EmMain />} />
            <Route path="leaves" element={<EmLeaves />} />
          </Route>
    
      </Routes>
    </div>
  );
}

export default App;
